import { EEximErrorType } from '@adaptiva/core/exim';

export const PLATFORM_EXIM_RESOLVER_OVERLAYS: Map<EEximErrorType, string> = new Map<EEximErrorType, string>([
	[EEximErrorType.FOLDER_NOT_SPECIFIED, 'ResolveFolderSelectionOverlay'],
	[EEximErrorType.EXPORT_ERROR_BUSINESS_UNIT_CHILD_SELECTION, 'ResolveBusinessUnitChildSelectionOverlay'],
	[EEximErrorType.IMPORT_ERROR_BUSINESS_UNIT_PARENT_SELECTION, 'ResolveBusinessUnitParentSelectionOverlay'],
]);
